import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name.' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    clientname: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Last Name*',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone Number*',
           mapping: 'telnumber'
         }
       ]
     },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address*',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Company or Event Name',
              mapping: 'clientname'
            },
           ]
          },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date',
              mapping: 'eventDate'
            }
          ]
        },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Number of Guests',
                mapping: 'plannedguestcount'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Comments / Notes',
                mapping: 'notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Taboo Muskoka Resort & Golf Contact Us Form',
    formId: '503',
    clientKey: 'BD78FAE2-CCF1-4C2E-92EA-A89BA5660A41',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/taboo/form_structure.js